import { Card } from '../ui';
import { cn } from '../../lib/cn';

type Props = {
  keywords?: Record<string, string[]>;
  types?: string[];
};

const TYPE_LABELS: Record<string, string> = {
  primary: 'Primary',
  secondary: 'Secondary',
  semantic: 'Semantic',
  regional: 'Regional',
  seasonal: 'Seasonal',
  negative: 'Negative',
  suggested: 'AI Suggested',
};

export function KeywordEngineCard({ keywords = {}, types = [] }: Props) {
  const entries = Object.entries(keywords);

  return (
    <Card padding="sm" className="border-brand-200 bg-brand-50/20 dark:border-brand-900 dark:bg-brand-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">AI Keyword Engine</p>
      <div className="mt-3 space-y-3">
        {entries.map(([type, kws]) => (
          <div key={type}>
            <p className="text-xs font-medium text-slate-500">{TYPE_LABELS[type] ?? type}</p>
            <div className="mt-1 flex flex-wrap gap-1">
              {kws.map((kw) => (
                <span
                  key={kw}
                  className={cn(
                    'rounded border px-2 py-0.5 text-xs',
                    type === 'negative'
                      ? 'border-error-200 bg-error-50 text-error-700 dark:border-error-900 dark:bg-error-950 dark:text-error-300'
                      : type === 'suggested'
                        ? 'border-ai-200 bg-ai-50 text-ai-700 dark:border-ai-800 dark:bg-ai-950 dark:text-ai-300'
                        : 'border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900',
                  )}
                >
                  {kw}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
      {types.length > 0 && (
        <p className="mt-3 text-xs text-slate-400">{types.length} keyword types supported</p>
      )}
    </Card>
  );
}
